// extracted by mini-css-extract-plugin
export default {"ContainerBlock":"Style_ContainerBlock__YcZDG"};